export const folderCelebrationsFrag = `            
    id
    serviceId
    person {
        id
        image
    
        titleBeforeName
        titleAfterName
        name
        surname

        alias
        birthSurname
        sex

        birthdate
    }
`;
